import { AlternativeWithoutExisting } from "src/helpers/types";
import AlternativesExplanationMap from "../AlternativesExplanationMap";
import AlternativesCarouselCard from "./AlternativesCarouselCard";
import { TypographyP } from "../Typography";
import { TextId } from "src/Translations";

export default function AlternativesExplanationDetails() {
  return (
    <AlternativesCarouselCard
      alternatives={[
        "NB_Only",
        "SB_Only",
        "Converging_Diverging_Short",
        "Converging_Diverging",
      ]}
      map={(alternative) => (
        <AlternativesExplanationMap
          alternative={alternative as AlternativeWithoutExisting}
        />
      )}
    >
      {(alternative) => (
        <div className="p-4">
          <TypographyP textId={`altDescription-${alternative}` as TextId} />
          <TypographyP
            textId="policeStationNote"
            className="mt-4 text-sm text-gray-500"
          />
        </div>
      )}
    </AlternativesCarouselCard>
  );
}
